import styled from 'styled-components';
import colors from '../../../../../../../styles/colors';

const ExcludeSection = styled.div`
  margin-top: 16px;
`;

const ExcludeDrawerContainer = styled.div`
  border: 1px solid ${colors.shades.secondary4};
  border-radius: 6px;
  overflow: hidden;
  background: ${({ $isOpen }) => ($isOpen ? colors.base.alpha : colors.base.gamma)};
`;

const ExcludeDrawerToggle = styled.button`
  width: 100%;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
`;

const ExcludeDrawerChevron = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${colors.shades.gamma2};
  transition: transform 150ms ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'none')};
`;

const ExcludeDrawerContent = styled.div`
  padding: 12px;
  border-top: 1px solid ${colors.shades.secondary4};
`;

const ExclusionSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${colors.shades.gamma11};
  margin: 0 0 6px 4px;

  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.base.danger};
    flex-shrink: 0;
  }
`;

export {
  ExcludeSection,
  ExcludeDrawerContainer,
  ExcludeDrawerToggle,
  ExcludeDrawerChevron,
  ExcludeDrawerContent,
  ExclusionSummary,
};
